import { render, staticRenderFns } from "./InformacoesGeraisAdd.vue?vue&type=template&id=55d05dbf"
import script from "./InformacoesGeraisAdd.vue?vue&type=script&lang=js"
export * from "./InformacoesGeraisAdd.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGeraisAdd.vue?vue&type=style&index=0&id=55d05dbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VIcon,VRow})
